import {connect} from 'react-redux';
import VirtualEventList from './VirtualEventList.jsx';
import {handleVirtualEventItemClick, handleIsHideFromCaptainClick} from './actions';

const mapStateToProps = state => ({
  source: state.tournament.events.virtualEvents,
  tournamentId: state.tournament.base.tournamentInfo.id,
  status: state.tournament.base.tournamentInfo.statusDisplayName
});

const mapDispatchToProps = dispatch => ({
  onVirtualEventItemClick: virtualEventId => dispatch(handleVirtualEventItemClick(virtualEventId)),
  onIsHideFromCaptainClick: (tournamentId, virtualEventId, event) => dispatch(handleIsHideFromCaptainClick(tournamentId, virtualEventId, event))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEventList);



// WEBPACK FOOTER //
// ./src/features/tournament/events/VirtualEventListContainer.jsx